import { createContext, useContext } from "react";

export const GUIDED_MODE_STORAGE_KEY = "flow-wizard.guided-mode.v1";

export interface GuidedModeContextValue {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
}

export const GuidedModeContext =
  createContext<GuidedModeContextValue | null>(null);

export function storedGuidedMode(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(GUIDED_MODE_STORAGE_KEY) === "on";
  } catch {
    return false;
  }
}

export function useGuidedMode(): GuidedModeContextValue {
  const context = useContext(GuidedModeContext);
  if (context === null) {
    throw new Error("useGuidedMode must be used within GuidedModeProvider.");
  }
  return context;
}
